// Provides resilient error log delivery with exponential backoff and localStorage queueing

const ERROR_LOG_QUEUE_KEY = 'error_log_queue_v1';
const MAX_RETRIES = 5;
const BASE_DELAY_MS = 1000; // 1s base
const JITTER_MS = 250; // small jitter to avoid thundering herd

const loadQueue = () => {
  try {
    const raw = localStorage.getItem(ERROR_LOG_QUEUE_KEY) || '[]';
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) { return []; }
};

const saveQueue = (queue) => {
  try { localStorage.setItem(ERROR_LOG_QUEUE_KEY, JSON.stringify(queue)); } catch (e) {}
};

const scheduleDelay = (attempt) => {
  const jitter = Math.floor(Math.random() * JITTER_MS);
  const delay = Math.min(BASE_DELAY_MS * Math.pow(2, attempt), 60000) + jitter;
  return new Promise((resolve) => setTimeout(resolve, delay));
};

export default function errorReportingQueue(requests){
  let flushing = false;

  const flushQueue = async () => {
    if (flushing) return;
    flushing = true;
    try {
      let queue = loadQueue();
      let next = [];
      for (let i = 0; i < queue.length; i++) {
        const item = queue[i];
        try {
					await sendRequest(item.payload, item.ts);
				} catch (e) {
          const attempt = (item.attempt || 0) + 1;
          if (attempt <= MAX_RETRIES) {
            next.push({ ...item, attempt });
          }
          // Item exceeded MAX_RETRIES - not added to next queue, effectively deleted
        }
      }
      saveQueue(next);
    } finally {
      flushing = false;
    }
  };
	const sendRequest = async (payload, ts = null) => {
		const response = await requests.postReturnError('error_log/create', {...payload, ts}, null, false);
		if(response?.error){
			// eslint-disable-next-line no-throw-literal
			throw response?.error;
		}
		return response;
	}

  const create = async (payload) => {
    try {
      await sendRequest(payload);
    } catch (e) {
			if(e?.response?.status === 401){
				return;
			}
      // enqueue and background retry with exponential backoff
      const queue = loadQueue();
			if(queue.length > 20)return;
      queue.push({ payload, attempt: 0, ts: Date.now() });
      saveQueue(queue);
      // best-effort background retry
      for (let attempt = 0; attempt < MAX_RETRIES; attempt++) {
        await scheduleDelay(attempt);
        try {
					await sendRequest(payload);
					let current = loadQueue();
          const idx = current.findIndex((x) => JSON.stringify(x.payload) === JSON.stringify(payload));
          if (idx > -1) { current.splice(idx, 1); saveQueue(current); }
          return;
        } catch (_e) {
          // continue loop
        }
      }
      // give up for now; queued for next app start flush
    }
  };

  return { create, flushQueue };
}


